import React, { useState, useEffect } from "react";
import * as _ from "lodash";
import { getInfoInvPrint, getInvData } from "../ShareFunctionsPrint";
import NewCashairCon from "../CasherNewDisigen/NewCashairCon";
import DefaultCashairCon from "../CashierNoTax/DefaultCashairCon";
import ReadyCashiarCon from "./ReadyCashiarCon";
import LoadingPage from "../../../services/LoadingPage";

function InvoiceCashiarCon(props) {
    const { typeInv,locInv,onUnmountComplete,premiApp,foundData,setFoundData} = props;
    const [found, setFound] = useState({});
    const [sta, setSta] = useState({});
    // const [inv, setInv] = useState(locInv?.invs);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const setAppInv = typeInv===2?false:true;
    const omlat = false;
    const empFound =false;

    useEffect(() => {
        setTimeout(async () => {
            await getInfoInvPrint(locInv, setData, setSta,premiApp, omlat, empFound,setAppInv,foundData,setFoundData);
            // await getInvData(setInv, locInv.proc_id);
            setLoading(false);
        }, 0);
    }, []);
    if (!foundData?.found || !sta ||  loading) return <LoadingPage />;
    return (
        <div>
            {typeInv == 1 ? <ReadyCashiarCon {...{ locInv, found:foundData?.found, sta, inv:locInv?.invs, data, onUnmountComplete,premiApp }} /> :
                     typeInv == 2 ? <NewCashairCon {...{ locInv, found:foundData.found, sta, inv:locInv?.invs, data,onUnmountComplete, premiApp }} /> :
                     typeInv == 3 ? <DefaultCashairCon {...{ locInv, found:foundData?.found, sta, inv:locInv?.invs, data,onUnmountComplete, premiApp }} /> :
                     <NewCashairCon {...{ locInv, found:foundData?.found, sta, inv:locInv?.invs, data,onUnmountComplete, premiApp }} /> }
        </div>
    );
}
export default InvoiceCashiarCon;
